import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { WorkflowTriggerType } from '@/modules/workflow/enums/WorkflowTriggerType';
import { WorkflowEstateStatusFormSelectConfig } from '@/modules/workflow/models/WorkflowEstateStatusFormSelectConfig';
import { WorkflowGuidanceStepFormSelectConfig } from '@/modules/workflow/models/WorkflowGuidanceStepFormSelectConfig';
import { WorkflowNotaryStatusFormSelectConfig } from '@/modules/workflow/models/WorkflowNotaryStatusFormSelectConfig';

export class WorkflowTrigger extends BaseModel {
  type?: string;
  trigger?: string | number;
  triggerText?: string;
  statusText?: string;
  statusColor?: string;

  constructor(model: Partial<WorkflowTrigger> = {}) {
    super();

    this.type = model.type;
    this.trigger = model.trigger;
    this.triggerText = model.triggerText;
    this.statusText = model.statusText;
    this.statusColor = model.statusColor;
  }

  getTriggerSelectConfig(workflowType?: string): FormSelectConfig | undefined {
    switch (this.type) {
      case WorkflowTriggerType.ESTATE_STATUS_CHANGED.key:
      case WorkflowTriggerType.ESTATE_HEALTH_CHECK_RECOMMENDATION_STATUS_CHANGED.key:
        return new WorkflowEstateStatusFormSelectConfig({ workflowType });
      case WorkflowTriggerType.GUIDANCE_STEP_COMPLETED.key:
        return new WorkflowGuidanceStepFormSelectConfig();
      case WorkflowTriggerType.NOTARY_STATUS_CHANGED.key:
        return new WorkflowNotaryStatusFormSelectConfig();
      default:
        return undefined;
    }
  }
}
